import {inlineError, tracer} from '@s-ui/decorators/lib'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class CheckPhoneVerificationStatusUserUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Service} deps.checkPhoneVerificationStatusUserService
   * @param {Service} deps.getCurrentUserService
   * @param {EntityFactory} deps.userEntityFactory
   * @param {ErrorFactory} deps.userNotLoggedInUserErrorFactory
   */
  constructor({
    checkPhoneVerificationStatusUserService,
    fromUserRawDataToUserEntityMapper,
    getCurrentUserService,
    userEntityFactory,
    userNotLoggedInUserErrorFactory
  }) {
    super()
    this._checkPhoneVerificationStatusUserService = checkPhoneVerificationStatusUserService
    this._getCurrentUserService = getCurrentUserService
    this._userEntityFactory = userEntityFactory
    this._userNotLoggedInUserErrorFactory = userNotLoggedInUserErrorFactory
  }

  @tracer({metric: 'CheckPhoneVerificationStatusUserUseCase#execute'})
  @inlineError
  async execute(params) {
    const currentUserEntity = await this._getCurrentUserService.execute()

    if (!currentUserEntity)
      return Promise.reject(
        this._userNotLoggedInUserErrorFactory({
          message: 'To check phone verification status the user must be logged in'
        }).toJSON()
      )

    const userEntity = this._userEntityFactory({
      phone: params.phone,
      userId: currentUserEntity.getId()
    })

    const [error, response] = await this._checkPhoneVerificationStatusUserService.execute({
      userEntity
    })

    return error ? Promise.reject(error) : response.toJSON()
  }
}
